import React from 'react';

const Logo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { width: 50, height: 50 },
    default: { width: 70, height: 70 },
    large: { width: 90, height: 90 }
  };
  
  const { width, height } = sizes[size] || sizes.default;
  
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 120 120" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Gold Gradients */}
        <linearGradient id="goldGradientMain" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#F4E4BA', stopOpacity: 1 }} />
          <stop offset="25%" style={{ stopColor: '#D4AF37', stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: '#C9A55A', stopOpacity: 1 }} />
          <stop offset="75%" style={{ stopColor: '#D4AF37', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#8B7355', stopOpacity: 1 }} />
        </linearGradient>
        
        <linearGradient id="goldGradientShine" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#FFF8DC', stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: '#D4AF37', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#8B7355', stopOpacity: 1 }} />
        </linearGradient>
        
        <linearGradient id="navyGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#0A1628', stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: '#152238', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#0A1628', stopOpacity: 1 }} />
        </linearGradient>
        
        {/* Shadow filter */}
        <filter id="logoShadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="2" stdDeviation="3" floodColor="#C9A55A" floodOpacity="0.3"/>
        </filter>
        
        {/* Glow filter */}
        <filter id="goldGlow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Outer Shield with 3D effect */}
      <path 
        d="M60 5 L105 22 L105 58 Q105 95 60 115 Q15 95 15 58 L15 22 Z" 
        fill="url(#navyGradient)"
        stroke="url(#goldGradientMain)"
        strokeWidth="3"
        filter="url(#logoShadow)"
      />
      
      {/* Inner Shield Border */}
      <path 
        d="M60 12 L98 27 L98 56 Q98 88 60 106 Q22 88 22 56 L22 27 Z" 
        fill="none"
        stroke="url(#goldGradientMain)"
        strokeWidth="1.5"
        opacity="0.7"
      />
      
      {/* Decorative Inner Shield */}
      <path 
        d="M60 18 L92 31 L92 54 Q92 82 60 98 Q28 82 28 54 L28 31 Z" 
        fill="url(#navyGradient)"
        stroke="url(#goldGradientShine)"
        strokeWidth="1"
        opacity="0.5"
      />
      
      {/* Scale of Justice - Enhanced */}
      <g fill="url(#goldGradientMain)" filter="url(#goldGlow)">
        {/* Center Pillar with ornament */}
        <rect x="57" y="32" width="6" height="45" rx="2" />
        <circle cx="60" cy="30" r="4" />
        <rect x="55" y="75" width="10" height="4" rx="1" />
        
        {/* Top Balance Bar */}
        <rect x="32" y="34" width="56" height="4" rx="2" />
        
        {/* Left Chain & Pan */}
        <line x1="35" y1="38" x2="28" y2="55" stroke="url(#goldGradientMain)" strokeWidth="2" />
        <line x1="35" y1="38" x2="42" y2="55" stroke="url(#goldGradientMain)" strokeWidth="2" />
        <path d="M24 55 Q35 62 46 55" fill="none" stroke="url(#goldGradientMain)" strokeWidth="2.5" />
        <ellipse cx="35" cy="58" rx="12" ry="4" />
        
        {/* Right Chain & Pan */}
        <line x1="85" y1="38" x2="78" y2="55" stroke="url(#goldGradientMain)" strokeWidth="2" />
        <line x1="85" y1="38" x2="92" y2="55" stroke="url(#goldGradientMain)" strokeWidth="2" />
        <path d="M74 55 Q85 62 96 55" fill="none" stroke="url(#goldGradientMain)" strokeWidth="2.5" />
        <ellipse cx="85" cy="58" rx="12" ry="4" />
      </g>
      
      {/* QH Initials - Elegant */}
      <text 
        x="60" 
        y="92" 
        textAnchor="middle" 
        fill="url(#goldGradientMain)" 
        fontSize="16" 
        fontFamily="Georgia, serif" 
        fontWeight="bold"
        letterSpacing="4"
        filter="url(#goldGlow)"
      >
        QH
      </text>
      
      {/* Decorative dots */}
      <circle cx="42" cy="88" r="2" fill="url(#goldGradientMain)" opacity="0.7" />
      <circle cx="78" cy="88" r="2" fill="url(#goldGradientMain)" opacity="0.7" />
    </svg>
  );
};

export default Logo;
